import React from "react";
import BaseComponent from "../BaseComponent.js";
import { Redirect } from "react-router";
import styled from "styled-components";
import nota from "../Global/nota.guidelines.json";
import { urlExists } from "./../Global/tools.js";

import NanoFlex from "../Global/NanoFlex.js";
import Type from "../Global/Typography";
import ViewMore from "./../Nano/ViewMore.js";
import TitleCard from "./../Nano/TitleCard.js";

import download from "../Global/Icons/download.svg";
import playIcon from "./../Global/Icons/play.svg";
import DefaultVideo from "./../../images/defaultVideo.svg";

const multiple = nota.global.multiple;

const InsightsBlockStyle = styled(NanoFlex)`
  width: 100%;
  height: 220px;
  margin: ${multiple + "px"};
  /* padding: ${multiple + "px"}; */
  .infoContainer {
    /* width: 55%; */
    width: 100%;
    border: 1px solid ${nota.color.main.default};
    border-top: 3px solid ${nota.color.main.default};
    padding: 12px;
    position: relative;

    .clickableWrapper {
      width: calc(100% - 100px);
    }

    .titleContainer {
      margin-left: 0;
      /* .titleWrapper {
        margin-bottom: ${multiple * 4 + "px"};
      } */
    }

    .wrapperText {
      width: 100%;
      max-height: 85px;
      margin-top: ${multiple + "px"}; /* 8px */
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 5;
      -webkit-box-orient: vertical;
    }
    .downloadCtaWrapper {
      width: 136px;
      .downloadCta {
        max-width: 100px;
        min-height: 105px;
        background-color: ${nota.color.neutral.white};
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
        padding: ${multiple / 2 + "px"}; /* 4px */
        position: relative;
        cursor: pointer;
        .wrapperTop {
          padding: ${multiple + "px"}; /* 8px */
          background-color: ${nota.color.main.default};
          position: relative;
          h4 {
            text-transform: uppercase;
            b {
              color: ${nota.color.neutral.white};
            }
          }
          &:after {
            content: "";
            display: block;
            position: absolute;
            bottom: -7px;
            left: 50%;
            transform: translateX(-50%);
            width: 0;
            height: 0;
            border-left: 7px solid transparent;
            border-right: 7px solid transparent;
            border-top: 7px solid ${nota.color.main.default};
          }
        }
        p {
          color: ${nota.color.main.default};
          font-size: 11px;
          text-align: center;
          margin-top: 6px;
        }
        .iconWrapper {
          position: absolute;
          top: -16px;
          right: -16px;
          width: 35px;
          height: 35px;
          box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
          background-color: ${nota.color.neutral.white};
          border-radius: 100%;
        }
        &:hover {
          opacity: 0.7;
        }
      }
      @media only screen and (max-width: ${nota.global.breakpoints.smallTablet + "px"}) {
        width: 150px;
        .downloadCta {
          transform: scale(0.6);
        }
      }
    }

    &:after,
    &:before {
      left: 100%;
      top: 50%;
      border: solid transparent;
      content: " ";
      height: 0;
      width: 0;
      position: absolute;
      pointer-events: none;
    }

    &:after {
      border-color: rgba(255, 255, 255, 0);
      border-left-color: ${nota.color.neutral.white};
      border-width: 30px;
      margin-top: -30px;
    }
    &:before {
      border-color: rgba(0, 168, 225, 0);
      border-left-color: ${nota.color.main.default};
      border-width: 31.5px;
      margin-top: -31.5px;
    }
  }
  .videoContainer {
    /* width: 45%; */
    width: 80%;
    .bckVideo {
      background-color: ${nota.color.neutral.NeuThree};
      width: 100%;
      height: 140px;
      .videoWrapper {
        width: 392px;
        height: 220px;
        background-color: ${nota.color.neutral.NeuTwo};
        position: relative;
        cursor: pointer;
        .imgVideoWrapper {
          width: 100%;
          height: 220px;
          overflow: hidden;
          img,
          video {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }
        .iconVideoWrapper {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          img {
            transition: all 0.3s ease-in-out;
          }
        }
        &:hover {
          .iconVideoWrapper {
            img {
              transition: all 0.3s ease-in-out;
              transform: scale(1.2);
            }
          }
        }
      }
    }
    .videoWrapper {
      width: 392px;
      height: 220px;
      background-color: ${nota.color.neutral.NeuTwo};
      position: relative;
      cursor: pointer;
      .imgVideoWrapper {
        width: 100%;
        height: 220px;
        overflow: hidden;
        img,
        video {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
      .iconVideoWrapper {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        img {
          transition: all 0.3s ease-in-out;
        }
      }
      &:hover {
        .iconVideoWrapper {
          img {
            transition: all 0.3s ease-in-out;
            transform: scale(1.2);
          }
        }
      }
    }
  }

  .linkMobile {
    margin-top: 8px;
    cursor: pointer;
    user-select: none;
    .linkStyle {
      text-transform: none;
      cursor: pointer;
      color: ${nota.color.main.default};
      &:hover {
        font-style: italic;
      }
    }
  }

  /* MEDIA QUERIES */
  @media only screen and (max-width: ${nota.global.breakpoints.laptop + "px"}) {
    .videoContainer {
      width: 100%;
    }
  }
  @media only screen and (max-width: ${nota.global.breakpoints.smallLaptop + "px"}) {
    height: 200px;
    .infoContainer {
      .wrapperText {
        -webkit-line-clamp: 3;
      }
    }
    .videoContainer {
      .bckVideo {
        height: 130px;
        .videoWrapper {
          width: 322px;
          height: 180px;
          .imgVideoWrapper {
            height: 180px;
          }
        }
      }
    }
  }
  @media only screen and (max-width: ${nota.global.breakpoints.tablet + "px"}) {
    .infoContainer {
      .wrapperText {
        -webkit-line-clamp: 2;
      }
    }
    .videoContainer {
      .bckVideo {
        height: 120px;
        .videoWrapper {
          width: 287px;
          height: 160px;
          .imgVideoWrapper {
            height: 160px;
          }
        }
      }
    }
  }
  @media only screen and (max-width: ${nota.global.breakpoints.smallTablet + "px"}) {
    .titleWrapper {
      align-items: start;
      flex-direction: column;
      .secondaryTitleWrapper {
        margin-left: 0;
      }
    }
  }

  @media only screen and (max-width: 1000px) {
    height: auto;
    .mainContainer {
      height: auto;

      .infoContainer {
        .titleContainer {
          width: 100%;
          .titleWrapper {
            margin-bottom: 16px;
          }
        }
        .videoContainer {
          margin-top: 16px;
          .videoWrapper {
            height: auto;
            width: 100%;
            .imgVideoWrapper {
              height: auto;
            }
          }
        }
        &:before {
          display: none;
        }
        &:after {
          display: none;
        }
      }
    }
  }

  @media only screen and (max-width: 300px) {
    margin: 8px 0;
  }
`;

class InsightsBlock extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = {
      openVideo: false,
      hasPdf: false,
      hasVideo: false,
      hasImage: false,
      redirect: false,

      isSmallScreen: this.isSmallScreen(),
    };

    this.videoRef = React.createRef();
    this.videoSmallRef = React.createRef();
  }

  componentDidMount() {
    super.componentDidMount();
    window.addEventListener("resize", this.onResize, false);
    window.addEventListener("displaySearchChanged", this.onDisplaySearchChanged, false);
    window.addEventListener("visibilitychange", this.onVisibilitychange, false);

    this.validateUrlFromProps();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.data !== this.props.data) {
      this.validateUrlFromProps();
    }

    if (this.state.redirect) {
      this.setState({ redirect: false });
    }
  }

  componentWillUnmount() {
    super.componentWillUnmount();
    window.removeEventListener("resize", this.onResize, false);
    window.removeEventListener("displaySearchChanged", this.onDisplaySearchChanged, false);
    window.removeEventListener("visibilitychange", this.onVisibilitychange, false);
  }

  onResize = (e) => {
    let newIsSmallScreen = this.isSmallScreen();
    if (newIsSmallScreen !== this.state.isSmallScreen) {
      //Set Is Mobile
      this.setState({ isSmallScreen: newIsSmallScreen });
    }
  };

  onDisplaySearchChanged = (e) => {
    if (e.detail === true) {
      if (this.videoRef?.current?.pause) this.videoRef.current.pause();
      if (this.videoSmallRef?.current?.pause) this.videoSmallRef.current.pause();
    }
  };

  onVisibilitychange = () => {
    if (this.videoRef?.current?.pause) this.videoRef.current.pause();
    if (this.videoSmallRef?.current?.pause) this.videoSmallRef.current.pause();
  };

  isSmallScreen = () => {
    return document.documentElement.clientWidth <= 1000;
  };

  openPdf = () => {
    window.open(this.props.data.pdf, "_blank");
  };

  openVideo = () => {
    this.setState({ openVideo: true });
  };

  validateUrlFromProps = () => {
    urlExists(this.props.data.video, (val) => {
      this.setState({ hasVideo: val });
    });
    urlExists(this.props.data.pdf, (val) => {
      this.setState({ hasPdf: val });
    });
    urlExists(this.props.data.image, (val) => {
      this.setState({ hasImage: val });
    });
  };

  render() {
    if (this.state.redirect) return <Redirect to="/Reports" />;
    return (
      <InsightsBlockStyle>
        <NanoFlex className="mainContainer">
          <NanoFlex className="infoContainer" flexDirection={"column"} alignItems={"flex-start"} justifyContent={"flex-start"}>
            <div
              className="clickableWrapper"
              onClick={() => {
                this.setState({ redirect: true });
              }}
            >
              <ViewMore />
              <TitleCard title={this.translation.home.insights.title} secTitle={""} />
            </div>
            <NanoFlex>
              <NanoFlex flexDirection={"column"} alignItems={"flex-start"}>
                <Type.h5>
                  <b>{this.props.data.title}</b>
                </Type.h5>
                <div className="wrapperText">
                  <Type.p justify>{this.props.data.summary}</Type.p>
                </div>
                {this.state.isSmallScreen && this.state.hasPdf && (
                  <NanoFlex className="linkMobile" justifyContent="flex-end" alignItems={"flex-end"}>
                    <Type.p className="linkStyle" onClick={this.openPdf}>
                      Download PDF
                    </Type.p>
                  </NanoFlex>
                )}
              </NanoFlex>

              {!this.state.isSmallScreen && this.state.hasPdf && (
                <NanoFlex className="downloadCtaWrapper">
                  <div className="downloadCta" onClick={this.openPdf}>
                    <div className="wrapperTop">
                      <Type.h4>
                        <b>{this.translation.reports.readLatestReport}</b>
                      </Type.h4>
                    </div>
                    <Type.p>
                      <em>{this.translation.reports.downloadPdf}</em>
                    </Type.p>
                    <NanoFlex className="iconWrapper">
                      <img src={download} alt="download" />
                    </NanoFlex>
                  </div>
                </NanoFlex>
              )}
            </NanoFlex>
            {this.state.isSmallScreen && (
              <NanoFlex className="videoContainer">
                <NanoFlex className="videoWrapper">
                  <div className="imgVideoWrapper">
                    {this.state.openVideo && (
                      <video
                        autoPlay
                        controls
                        ref={this.videoSmallRef}
                        style={{
                          objectFit: "contain", // Prevents cropping
                        }}
                      >
                        <source src={`${this.props.data.video}#t=0.1`} type="video/mp4" />
                      </video>
                    )}
                    {!this.state.openVideo && (
                      <div>
                        <img src={this.state.hasImage ? this.props.data.image : DefaultVideo} alt="Default Card" />
                        {this.state.hasVideo && (
                          <div className="iconVideoWrapper" onClick={this.openVideo}>
                            <img src={playIcon} alt="Play Icon" />
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </NanoFlex>
              </NanoFlex>
            )}
          </NanoFlex>
          {!this.state.isSmallScreen && (
            <NanoFlex className="videoContainer">
              <NanoFlex className="bckVideo">
                <NanoFlex className="videoWrapper">
                  <div className="imgVideoWrapper">
                    {this.state.openVideo && (
                      <video
                        autoPlay
                        controls
                        ref={this.videoRef}
                        style={{
                          objectFit: "contain", // Prevents cropping
                        }}
                      >
                        <source src={`${this.props.data.video}#t=0.1`} type="video/mp4" />
                      </video>
                    )}
                    {!this.state.openVideo && (
                      <div>
                        <img src={this.state.hasImage ? this.props.data.image : DefaultVideo} alt="Default Card" />
                        {this.state.hasVideo && (
                          <div className="iconVideoWrapper" onClick={this.openVideo}>
                            <img src={playIcon} alt="Play Icon" />
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </NanoFlex>
              </NanoFlex>
            </NanoFlex>
          )}
        </NanoFlex>
      </InsightsBlockStyle>
    );
  }
}

export default InsightsBlock;

/*
import LoginBackground from '../../Micro/InsightsBlock.js';

<InsightsBlock />
*/
